import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, d as _extends, c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import { createElement, Component } from 'react';
import { oneOf, bool, oneOfType, number, string } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import '@emotion/is-prop-valid';
import { findDOMNode } from 'react-dom';
import { a as hoist } from './chunk-0cd02bff.js';
import { a as callAll } from './chunk-11bd1c20.js';
import Hidden from './Hidden.js';
import 'constate';
import { a as HiddenContainer } from './chunk-061cef7c.js';
import { c as HiddenToggle, b as HiddenShow, a as HiddenHide } from './chunk-22b2fb47.js';
import s from 'styled-selector';
import Popper from 'popper.js';
import { a as PopoverArrow } from './chunk-0599225e.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  user-select: auto;\n  cursor: auto;\n  z-index: 999;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PopoverComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PopoverComponent, _React$Component);

  function PopoverComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      placement: _this.props.placement,
      translateX: undefined,
      translateY: undefined,
      originX: undefined,
      originY: undefined
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popper", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopover", function () {
      return findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "modifier", function (data) {
      var placement = data.placement,
          offsets = data.offsets,
          arrowElement = data.arrowElement,
          arrowStyles = data.arrowStyles;
      var reference = offsets.reference,
          popper = offsets.popper;

      var _placement$split = placement.split("-"),
          position = _placement$split[0];

      var isVertical = ["top", "bottom"].indexOf(position) >= 0;
      var referenceCenter = isVertical ? reference.width / 2 : reference.height / 2;
      var side = isVertical ? "left" : "top";
      var sideValue = referenceCenter - popper[side];

      if (arrowElement) {
        var top = arrowStyles.top,
            left = arrowStyles.left;
        arrowElement.style.top = isVertical ? "" : top + "px";
        arrowElement.style.left = isVertical ? left + "px" : "";
      }

      _this.setState({
        originX: isVertical ? sideValue + "px - 50%" : 0,
        originY: !isVertical ? sideValue + "px - 50%" : 0,
        translateX: Math.round(popper.left),
        translateY: Math.round(popper.top),
        placement: data.placement
      });

      return data;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptions", function () {
      var _this$props = _this.props,
          placement = _this$props.placement,
          flip = _this$props.flip,
          shift = _this$props.shift;

      var popover = _this.getPopover();

      var arrow = popover.querySelector(s(PopoverArrow));
      return {
        placement: placement,
        modifiers: {
          hide: {
            enabled: false
          },
          applyStyle: {
            enabled: false
          },
          arrow: arrow ? {
            enabled: !!arrow,
            element: arrow
          } : undefined,
          flip: {
            enabled: flip,
            padding: 16
          },
          shift: {
            enabled: shift
          },
          offset: {
            offset: "0, " + _this.props.gutter
          },
          setState: {
            order: 900,
            enabled: true,
            fn: _this.modifier
          }
        }
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initPopper", function () {
      if (!_this.popper) {
        var popover = _this.getPopover();

        var parentNode = popover.parentNode;

        if (parentNode && getComputedStyle(parentNode).display !== "none") {
          _this.popper = new Popper(parentNode, popover, _this.getOptions());
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "destroyPopper", function () {
      if (_this.popper) {
        _this.popper.destroy();

        _this.popper = undefined;
      }
    });

    return _this;
  }

  var _proto = PopoverComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.initPopper();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.destroyPopper();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible || prevProps.placement !== this.props.placement || prevProps.children !== this.props.children) {
      this.destroyPopper();
      this.initPopper();
    }
  };

  _proto.getDefaultPlacement = function getDefaultPlacement() {
    var placement = this.state.placement;

    if (placement) {
      return placement.replace(/-.+$/, "");
    }

    return undefined;
  };

  _proto.render = function render() {
    var defaultPlacement = this.getDefaultPlacement();
    return createElement(Hidden, _extends({
      id: this.props.popoverId
    }, this.state, {
      "data-placement": this.state.placement,
      defaultSlide: defaultPlacement,
      defaultExpand: defaultPlacement,
      slideOffset: this.props.gutter
    }, this.props, {
      unmount: false
    }));
  };

  return PopoverComponent;
}(Component);

var Popover = styled(hoist(PopoverComponent, Hidden))(_templateObject(), theme("Popover")); // @ts-ignore

Popover.propTypes = {
  placement: oneOf(["auto", "top", "right", "bottom", "left", "top-start", "right-start", "bottom-start", "left-start", "top-end", "right-end", "bottom-end", "left-end"]),
  flip: bool,
  shift: bool,
  gutter: oneOfType([number, string]),
  popoverId: string
};
Popover.defaultProps = {
  role: "group",
  placement: "bottom",
  hideOnEsc: true,
  flip: true,
  shift: true,
  gutter: 12,
  opaque: true,
  palette: "white"
};
var Popover$1 = use(Popover, "div");

var id = -1;

var uniqueId = function uniqueId(prefix) {
  id += 1;
  return prefix ? "" + prefix + id : "" + id;
};

var onMount = function onMount(_ref) {
  var setState = _ref.setState;
  setState({
    popoverId: uniqueId("popover")
  });
};

var PopoverContainer = function PopoverContainer(props) {
  return createElement(HiddenContainer, _extends({}, props, {
    onMount: callAll(onMount, props.onMount)
  }));
};

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var PopoverToggleComponent = function PopoverToggleComponent(props) {
  return createElement(HiddenToggle, _extends({
    "aria-expanded": props.visible,
    "aria-controls": props.popoverId,
    "aria-haspopup": true
  }, props));
};

var PopoverToggle = styled(hoist(PopoverToggleComponent, HiddenToggle))(_templateObject$1(), theme("PopoverToggle")); // @ts-ignore

PopoverToggle.propTypes = {
  popoverId: string,
  visible: bool
};
var PopoverToggle$1 = use(PopoverToggle, "button");

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var PopoverShowComponent = function PopoverShowComponent(props) {
  return createElement(HiddenShow, _extends({
    "aria-expanded": props.visible,
    "aria-controls": props.popoverId,
    "aria-haspopup": true
  }, props));
};

var PopoverShow = styled(hoist(PopoverShowComponent, HiddenShow))(_templateObject$2(), theme("PopoverShow")); // @ts-ignore

PopoverShow.propTypes = {
  popoverId: string,
  visible: bool
};
var PopoverShow$1 = use(PopoverShow, "button");

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var PopoverHideComponent = function PopoverHideComponent(props) {
  return createElement(HiddenHide, _extends({
    "aria-expanded": props.visible,
    "aria-controls": props.popoverId,
    "aria-haspopup": true
  }, props));
};

var PopoverHide = styled(hoist(PopoverHideComponent, HiddenHide))(_templateObject$3(), theme("PopoverHide")); // @ts-ignore

PopoverHide.propTypes = {
  popoverId: string,
  visible: bool
};
var PopoverHide$1 = use(PopoverHide, "button");

var Popover$2 = Object.assign(Popover$1, {
  Arrow: PopoverArrow,
  Container: PopoverContainer,
  Toggle: PopoverToggle$1,
  Show: PopoverShow$1,
  Hide: PopoverHide$1
});

export default Popover$2;
